/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 03.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import ObjectField from "./ObjectField";

class ExpandableObjectField extends ObjectField {
    static propTypes = {
        registry: PropTypes.shape({
            widgets: PropTypes.objectOf(
                PropTypes.oneOfType([PropTypes.func, PropTypes.object])
            ).isRequired,
            fields: PropTypes.objectOf(PropTypes.func).isRequired,
            definitions: PropTypes.object.isRequired,
            formContext: PropTypes.shape({
                expanded: PropTypes.bool,
                expandedCallback: PropTypes.func,
                onSubmit: PropTypes.func,
                locale: PropTypes.string,
                params: PropTypes.shape({
                    path: PropTypes.string.isRequired,
                    resource: PropTypes.string.isRequired,
                    action: PropTypes.oneOf(["list","new","view","edit","delete"]).isRequired,
                    id: PropTypes.string,
                    query: PropTypes.object,
                    parentPath: PropTypes.string,
                    parentResource: PropTypes.string,
                    parentAction: PropTypes.oneOf(["list","new","view","edit","delete"]),
                    parentId: PropTypes.string,
                    parentField: PropTypes.string
                })
            }).isRequired,
        })
    };

    render() {
        let childFields = this.getChildFields();
        if (!childFields || !_.isArray(childFields) || childFields.length == 0) return (<div className="ibox-content" >{childFields}</div>)

        let firstField = childFields.shift();

        let expanded = true;
        if (this.props.registry.formContext && _.has(this.props.registry.formContext, "expanded") && !this.props.registry.formContext.expanded)
            expanded = false;

        return (
            <div>
                <div className="ibox-title">
                    {firstField}
                </div>
                {
                    expanded ?
                        (
                            <div className="ibox-content">
                                {childFields}
                            </div>
                        ) : ""
                }
            </div>
        );
    }
}

export default ExpandableObjectField;
